import { CostWeightType } from '../../common/PricePrgClient';

export type CostGroupCalculationResult = { [costGroupId: number]: number };
export type CostTypeDropped = {
    costGroupId: number | undefined;
    costTypeId: number | undefined;
    showDialog: boolean;
};
export const costTypes: { [key: number]: string } = {
    0: '%',
    1: ' per KG/ST',
    2: ' Per package',
    3: ' Per pallet',
    4: '% Product category cost',
    5: '% Product group cost',
    6: '% Product cost',
    7: ' per KG Product cost'
};

export const costGroupTypes: { [key: number]: string } = {
    0: 'Stand alone calculations',
    1: 'Grouped percentages'
};

export const getCostType = (currency: string, costType: number) => {
    switch (costType) {
        case 1:
        case 2:
        case 3:
        case 7:
            return `${currency} ${costTypes[costType]}`;
        default:
            return costTypes[costType];
    }
};

export type CostForm = {
    name?: string;
    amount: string;
    useBasePrice: boolean;
    costWeightType?: CostWeightType;
};
